import React from "react";
import compose from "lodash/flowRight";

export function composeContainers<
  InternalProps,
  ExposedProps = Record<string, unknown>,
>({
  containers,
  component: Component,
}: {
  containers: ((
    Component: React.FC
  ) => (props: InternalProps) => JSX.Element)[];
  component: (props: InternalProps) => React.ReactNode;
}): React.FC<ExposedProps> {
  return compose(...containers)(Component);
}
